$(document).ready(function() {
    var reqroom = 0;

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    if (gameusers !==undefined) {
        for (i = 0; i < gameusers.length; i++) {
            user = gameusers[i];
            $('#space_' + user['boardrow'] + '_' + user['boardcol']).addClass(user['character']['color']);
        }
    }

    if (game['currplayer_id'] == me) {
        $('#rolldice').prop("disabled", false);
    } else {
        $('#rolldice').prop("disabled", true);
    }

    function setAvailMoves(availmoves) {
        for (i = 0; i < availmoves.length; i++) {
            move = availmoves[i];
            $('#space_' + move[0] + '_' + move[1]).addClass('availmove');
        }
    }

    $('#rolldice').on('click', function(e) {
        e.preventDefault();
        $.getJSON("/game/" + game['id'] + "/" + me + "/roll", function(json) {
            setAvailMoves(json.availmoves);
            $('#rolldice').prop('disabled', true);
        });
    });


    $('.gamespace').on('click', function() {
        //
        if ($(this).hasClass('availmove')) {
            // alert('here');
            spaceid = $(this).attr('id').split('_');
            boardrow = spaceid[1];
            boardcol = spaceid[2];



            $.getJSON('/game/' + game['id'] + '/' + me + '/move/' + boardrow + '/' + boardcol, function(json) {


                if (json.roomcardid !== undefined) {
                    if(json.roomcardid != 0){
                      reqroom = json.roomcardid;
                      $('#request-room').html(json.room.name);
                      // $('#requestmodal').modal('show');
                      app.modalactive=true;
                      app.modaltype='request';
                    }else{

                      app.showdumbledoreoffice=true;
                    }

                }
            });

            $('.gamespace').removeClass('availmove');

        }

    });
    $('.X').removeClass('availmove');

    $('#saverequest').on('click', function() {
        app.modalactive=false;
        app.modaltype = '';

        reqdata = {
            'suspect': $('#request-suspect').val(),
            'item': $('#request-item').val(),
            'room': reqroom
        };

        $.post('/game/' + game['id'] + '/' + me + '/makerequest', reqdata);

    });

    $('#subshowcard').on('click', function(){
      $.get( "/game/"+game['id']+'/showcard/'+$('#showcard').val() );
      app.showcardmodalactive=false;
    });

    $('#seecards').on('click', function(e){
      e.preventDefault();
      $.getJSON("/game/" + game['id'] + "/" + me + "/seecards", function(json) {
          // setAvailMoves(json.availmoves);
          // $('#rolldice').prop('disabled', true);
      });
      app.showdumbledoreoffice=false;
    });

    $('#accuse').on('click', function(e){
      e.preventDefault();

      app.showdumbledoreoffice=false;
      // $('#accusemodal').modal('show');
      app.modalactive=true;
      app.modaltype = 'accuse';
    });

    $('#saveaccuse').on('click', function() {
        // $('#accusemodal').modal('hide');
        app.modalactive=false;
        app.modaltype = '';

        reqdata = {
            'suspect': $('#accuse-suspect').val(),
            'item': $('#accuse-item').val(),
            'room': $('#accuse-room').val(),
        };


        $.post('/game/' + game['id'] + '/' + me + '/accuse', reqdata);

    });


    $('.scorenote').on('change', function(){


      card = this.id.split("_");


      reqdata = {
          'note': $('#'+this.id).val(),

      };

      $.post('/game/' + game['id'] + '/' + me + '/'+card[1]+'/'+card[2]+'/saveNote', reqdata);
    });


});

function openRequest(request){
  $('#showname').html(userarr[request.touser]);
  $('#showcard').empty();

  selectValues={};
  if(mycards[request.suspect]!==undefined) selectValues[request.suspect] = mycards[request.suspect];
  if(mycards[request.item]!==undefined) selectValues[request.item] = mycards[request.item];
  if(mycards[request.room]!==undefined) selectValues[request.room] = mycards[request.room];




  $.each(selectValues, function(key, value) {
    $('#showcard')
    .append($('<option>', { value : key })
    .text(value));
  });

  // $('#showcardmodal').modal('show');
  app.showcardmodalactive=true;
}


Echo.channel('gamelog.' + game['id']+'.0')
    .listen('GameLogEntry', (e) => {
        $('#gamelog ul').prepend('<li class=\'is-size-7 logmessage\'>' + e.logentry.logtext + '</li>');
    });

    Echo.channel('gamelog.' + game['id']+'.'+me)
        .listen('GameLogEntry', (e) => {
            $('#gamelog ul').prepend('<li class=\'is-size-7 logmessage\'>' + e.logentry.logtext + '</li>');
        });

Echo.channel('nextturn.' + game['id'])
    .listen('NextTurn', (e) => {

        if (e.nextuser.id == me) {
            // alert('Your turn. Roll the dice.');
            $('#rolldice').prop('disabled', false);
        }
        $('.player').each(function(){
          $(this).removeClass('activeplayer');
        });
        $('#player_'+e.nextuser.id).addClass('activeplayer');
    });

Echo.channel('gamemove.' + game['id'])
    .listen('Move', (e) => {
        $('.gamespace').removeClass(e.player.character.color);
        $('#space_' + e.player.boardrow + '_' + e.player.boardcol).addClass(e.player.character.color);

    });

    Echo.channel('requestcard.' + me)
        .listen('RequestCard', (e) => {
            openRequest(e.request);

            // alert('show a card to '+userarr[e.request.touser]);

        });
        if (request !== undefined && request.fromplayer == me) openRequest(request);



// WEBPACK FOOTER //
// ./resources/assets/js/game.js